import loaderGif from "@Images/NewUI/loader_rocket.gif";
import "@Styles/mandate.css";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { payme_nbfc_heading, payme_nbfc_list } from "../../../../src/helper/modalConstant";
import ModalBox from "../../../helper/modalBox";
import { withRouter } from "../../../hooks/withRouter";
import DisclaimerImg from "../../../Images/NewUI/disclaimer.png";
import { mutualfundrediraction, referandearndiraction } from "../../../Redux/Manual_Kyc_Details/action";

import { nbfcDetails } from "../../../Redux/ApplyLoan/action";
import { HEADING_NBFCASSIGNED } from "../Common/constant";
import CountDown from "../Common/CountDown";
import { Loader } from "../Common/Loader";
import { trackDisbursed } from "../../../utils/metaPixel";

const NbfcAssigned = (props) => {
  const navigate = useNavigate();
  const token = props?.user?.User?.token || localStorage.getItem("gpay_token");
  const [modalState, setModalState] =  useState(false)

  const [show, setShow] = useState(false);
  const [nbfc_detail, setNbfcDetails] = useState("");
  const [loader, setLoader] = useState(true);
  const [waitloader, setWaitloader] = useState(false);
  const [isButtonDisabled, setIsButtonDisbled] = useState(false);
  const [nbfcTat, setNbfcTet] = useState("");
  const [redirectJunglee , setRedirectJunglee] = useState("");
  const [loanCount , setLoanCount] =useState("");
  const [jungleeDisclaimer, setJungleeDisclaimer] = useState("");


  const getLoanDetails=()=>{
    props
    .nbfcDetails(token)
    .then((res) => {
      setLoader(false);
      setNbfcDetails(res.data.data);
      setNbfcTet(res.data.data.nbfc_tat)
      setRedirectJunglee(res.data.data.junglee_game_link)
      setLoanCount(res.data.data.loan_count)
      setJungleeDisclaimer(res.data.data.nbfc_disclaimer)
      const detail = res.data.data;
      if (detail && (detail.loan_amount || detail.disbursal_amount)) {
        trackDisbursed({
          disbursedAmount: detail.loan_amount || detail.disbursal_amount,
          loanType: detail.loan_type || 'loan',
          nbfc_name: detail.nbfc_name,
          loan_status: detail.loan_status,
          disbursalDate: new Date().toISOString(),
        });
      }
    })

    .catch((err) => {
      setLoader(false);
      if (err.response?.status === 401) {
       window.location.href = "/";
        localStorage.removeItem("gpay_token");
      }
    });
  }

  useEffect(() => {
    getLoanDetails();
  }, []);

  const handleClose = () => setShow(false);
  
  const enableCustomerSupport = () => {
    setIsButtonDisbled(true);
  };

  const handlesupportbtn=()=>{
    
    if(isButtonDisabled === false){
      navigate("/nbfc_message")
    }
    else{
      navigate("/nbfc_assigned")
    }
  }

  return (
    <div id="background" className="main_div">
       <div className="pt-0">
         
         <div className="py-5 shadowline fixheadingassignednbfc sticky-header  align-items-center d-flex">
     
            
             <span
             className="boldheading headMarginDec " 
               style={{
                 //paddingLeft: "80px",
                 color: "#152745",
                 fontWeight: "1000",
                 fontSize: "26px",
                 
               }}
             >
               {HEADING_NBFCASSIGNED}
             </span>
               <div>
               {/* <img className="imageQuestionMark quetranslate" onClick={()=>{setModalState(true)}} src={questionImage}/> */}
               </div>

       </div>
      {loader?<Loader/>:null}
      <div className="container nbfc-container-with-bottom-padding">
       
          <div>
          <div className="wrapper-content e-sign mt-63">
            <div className="maxwidthcard rounded-20 px-4 pb-3 pt-1 w-100 text-center mx-auto  rounded-40 " style={{marginBottom:0}}>
              <div className="h-100 d-flex flex-column justify-content-between">
                {!waitloader ? (
                  <div className="">
                    <img
                      src={nbfc_detail?.nbfc_logo}
                      // alt="mamta"
                      style={{ maxWidth: "100%", margin: "0px 0px" }}
                    />
                    <br />
                    <br />
                    <br />
                    <p className="nbfc_name">{nbfc_detail?.nbfc_name}</p>
                    <br />
                    <div>
                      Disbursal in {nbfcTat} hours
                      <br />
                      <span className="paymecolour">
                        <CountDown
                          nbfcTat={nbfcTat}
                          tenure_date={nbfc_detail?.tenure_date}
                          enableCustomerSupport={enableCustomerSupport}
                        />
                      </span>
                    </div>
                  </div>
                ) : (
                  <div className="pt-4 pb-5">
                    <img
                      src={loaderGif}
                      alt="mamta"
                      style={{ width: 76, height: 75, margin: "0px 0px" }}
                    />

                    <p className="loader_msg">
                      Please wait until the disbursal period before contacting
                      support
                    </p>

                    <div className="font-500 paymecolour">
                      Disbursal in 24 hours  
                      <br /> 
                      <CountDown
                        className="font-500 paymecolour"
                        tenure_date={nbfc_detail?.tenure_date}
                        enableCustomerSupport={enableCustomerSupport}
                      />
                    </div>
                  </div>
                )}
                
              </div>
            </div>
          </div>
          
          
          <div className=" repaymentdisclaimer3 flex_row ">
                      <img style={{marginRight: 10,  marginLeft:10}} width={20} height={20} src={DisclaimerImg}></img>
                      <p className=" mr-10" style={{fontWeight:"600"}}>{jungleeDisclaimer}</p>
            </div>
  </div>
          {/* {loanCount === 1 ?
            <div onClick={() =>{perpRedirection()}} className="referral-banner-one">
              <img className="referral-banner-new-img" src={ReferNowimg} />
            </div>:

            <div onClick={() => {handleMutualFundUrl()}} className="referral-banner-one">
              <img className="referral-banner-new-img" src={GetNowimg} />
            </div>
            } */}

          {/* <div className="text-center" style={{marginTop: 20}}>
          <img onClick={()=>{handleJungleredirection()}} className="jaggleeimg" src={JanglEimg} />
         
          </div> */}
          
        </div>
      <div className="nbfc-fixed-button-wrapper">
        <div className={modalState === true ? "nbfcjanglee continueZindex" : "nbfcjanglee"}
          onClick={() => {
            handlesupportbtn();
            navigate("/super-loan-dashboard");
          }}
        >
          Back To Home
        </div>
      </div>
       


        <Modal show={show} onHide={handleClose} className="modal_flex">
          <Modal.Body>
            <div className="popup-div">
              <span className="heading-pop">How it works ?</span>

              <p>We work with multiple NBFC to facilitate the loan.</p>

              <ul>
                <li>Your loan application has been send to NBFC.</li>

                <li>The NBFC transfer the money directly into your account.</li>
              </ul>
            </div>

            <div className="button-wrapper text-center">
              <a
                className="btn bg-white text-white rounded-pill bg-whitee"
                onClick={handleClose}
              >
                Okay
              </a>
            </div>
          </Modal.Body>
        </Modal>
      </div>
          {modalState && <ModalBox statusDes={true} heading={payme_nbfc_heading} List={payme_nbfc_list} open={true} onChange={(props)=>{setModalState(props)}} imagesVisible={true}/> }

    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user, 
  };
};

export default withRouter(connect(mapStateToProps, { nbfcDetails, referandearndiraction , mutualfundrediraction })(NbfcAssigned));
